import { useReducer } from "react";
import CartContext from "./cart-context";
const defaultCartState = {
  items: [],
  totalAmount: 0,
};

const cartReducer = (state, action) => {
  if (action.type === "ADD") {
    const updateTotalAmount =
      state.totalAmount + action.item.price * action.item.amount;
    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.item.id
    );
    const existingCartItem = state.items[existingCartItemIndex];
    let updatedItems;

    if (existingCartItem) {
      //when the intem qty is increased
      const updatedItem = {
        ...existingCartItem,
        amount: existingCartItem.amount + action.item.amount,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    } else {
      //when item is added for the first item
      updatedItems = state.items.concat(action.item);
    }

    return {
      items: updatedItems,
      totalAmount: updateTotalAmount,
    };
  }
  if(action.type === 'REMOVE'){
      
    const existingCartItemIndex = state.items.findIndex(
        (item) => item.id === action.id
      );

      const existingItem = state.items[existingCartItemIndex];
      let updatedTotalAmount = state.totalAmount - existingItem.price;

      let updateItems;
      if(existingItem.amount ===1){
        updateItems = state.items.filter(item => item.id !== action.id );
        //check all items where the id is not equal to the action id are kept
        //This also creates a new array? 
      }else{
        const updatedItem = {...existingItem,amount:existingItem.amount -1}
        updateItems = [...state.items];
        updateItems[existingCartItemIndex] = updatedItem;
      }
      if(updatedTotalAmount < 0 ){
          updatedTotalAmount = 0;
      }
     
      return{
          items:updateItems,
          totalAmount:updatedTotalAmount
      }
   
  }

  return defaultCartState;
};

const CartProvider = (props) => {
  const [cartState, dispatchCartAction] = useReducer(
    cartReducer,
    defaultCartState
  );

  const addItemCartHandler = (item) => {
    dispatchCartAction({
      type: "ADD",
      item: item,
    });
  };
  const removeItemHandler = (id) => {
      dispatchCartAction({
          type:'REMOVE',
          id:id,
      });
  };

  const cartContext = {
    items: cartState.items,
    totalAmount: cartState.totalAmount,
    addItem: addItemCartHandler,
    removeItem: removeItemHandler,
  };
  return (
    <CartContext.Provider value={cartContext}>
      {props.children}
    </CartContext.Provider>
  );
};

export default CartProvider;
